<!--
categories wrapper
AT
07.06.21
-->

<script>
	import { onMount } from 'svelte'
	import CategoryMenu from './category-menu.svelte'

	export let parents

</script>

{ #each parents as parent }
	<CategoryMenu parents={ parents } parent={ parent } on:select on:deselect/>
{ /each }
